<script lang="ts">
  import Loading from '$lib/components/Loading.svelte';
  import type { LayoutProps } from './$types';
  import { page } from '$app/state';
  import TabbedCard from '$lib/components/common/TabbedCard.svelte';

  let { params, data, children }: LayoutProps = $props();

  let activePage = $derived.by(() => {
    if (page.route.id === '/(loginwrapper)/admin/courses/[id]/skills') {
      return 'skills';
    }

    return 'courseInfo';
  });
</script>

{#await data.coursePromise}
  <Loading />
{:then course}
  <h2 class="mb-3">{course.name}</h2>
  <TabbedCard
    tabs={[
      { title: 'Course Info', href: `/admin/courses/${params.id}`, active: activePage === 'courseInfo' },
      { title: 'Skills', href: `/admin/courses/${params.id}/skills`, active: activePage === 'skills' },
    ]}
  >
    {@render children?.()}
  </TabbedCard>
{/await}
